import { Button, Icon, Modal, Typography } from "@/components/atoms";

interface CancelSubscriptionModalProps {
  open: boolean;
  onClose: () => void;
  subscriptionEndDate: string;
  onCancel?: () => void;
  isCancelling?: boolean;
}

export const CancelSubscriptionModal = ({
  open,
  onClose,
  subscriptionEndDate,
  onCancel,
  isCancelling = false,
}: CancelSubscriptionModalProps) => {
  const handleConfirmCancel = () => {
    onCancel?.();
  };

  const warningIcon = (
    <div className="relative flex h-12 w-12 shrink-0 items-center justify-center rounded-full">
      <div className="absolute inset-[-4px] rounded-full border-8 border-danger-light" />
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-danger">
        <Icon name="Danger" size="lg" className="text-white" />
      </div>
    </div>
  );

  return (
    <Modal open={open} onClose={onClose} className="w-[85vw] md:w-[400px] lg:w-[400px]" featuredIcon={warningIcon}>
      <div className="flex flex-col">
        <Typography variant="title" className="text-neutral-dark-gray">
          Cancel Subscription?
        </Typography>
        <Typography variant="paragraph" className="mt-2 text-neutral-dark-gray">
          Your subscription will remain active until <span className="font-semibold">{subscriptionEndDate}</span>. You won&apos;t be charged
          again after this date.
        </Typography>

        <div className="mt-8 flex w-full flex-col gap-3">
          <Button
            variant="primary"
            size="lg"
            onClick={handleConfirmCancel}
            disabled={isCancelling}
            className="w-full !bg-danger hover:!bg-danger-dark"
          >
            {isCancelling ? "Cancelling..." : "Cancel Subscription"}
          </Button>
          <Button variant="secondary" size="lg" onClick={onClose} disabled={isCancelling} className="w-full">
            Keep Subscription
          </Button>
        </div>
      </div>
    </Modal>
  );
};
